module.exports = __webpack_public_path__ + "static/media/Success-sound-effect.5ba39ead.mp3";